import React, { useState } from 'react';
import useInstallPrompt from '../../hooks/useInstallPrompt';
import { useAnalytics } from '../../analytics/hooks';

/**
 * Platform-aware install trigger. Replaces dead footer store links.
 * - Android/Desktop Chrome/Edge: triggers native install prompt
 * - iOS Safari: shows instructional modal
 * - Hidden when already installed or unsupported browser
 */
const InstallButton = ({ className = '' }) => {
  const { isInstallable, isInstalled, isIOSSafari, promptInstall } = useInstallPrompt();
  const { track } = useAnalytics();
  const [showIOSModal, setShowIOSModal] = useState(false);

  // Hidden conditions
  if (isInstalled) return null;
  if (!isInstallable && !isIOSSafari) return null;

  const handleClick = () => {
    if (isIOSSafari) {
      setShowIOSModal(true);
      track('install_button_clicked', { platform: 'ios' });
      track('ios_modal_shown');
    } else {
      promptInstall();
      track('install_button_clicked', { platform: 'android_desktop' });
    }
  };

  const handleCloseModal = () => {
    setShowIOSModal(false);
    track('ios_modal_dismissed');
  };

  return (
    <>
      <button className={className} onClick={handleClick} type="button">
        Install JyotishSastra
      </button>
      {showIOSModal && (
        <div
          className="ios-install-overlay"
          onClick={handleCloseModal}
          role="dialog"
          aria-modal="true"
          aria-label="Install instructions for iOS"
        >
          <div className="ios-install-modal" onClick={(e) => e.stopPropagation()}>
            <h3 className="ios-install-modal__title">Install JyotishSastra</h3>
            <ol className="ios-install-modal__steps">
              <li>
                <span className="ios-install-modal__icon">&#x2B06;&#xFE0F;</span>
                Tap the <strong>Share</strong> icon at the bottom of Safari
              </li>
              <li>
                <span className="ios-install-modal__icon">&#x2795;</span>
                Scroll down and tap <strong>"Add to Home Screen"</strong>
              </li>
              <li>
                <span className="ios-install-modal__icon">&#x2705;</span>
                Tap <strong>"Add"</strong> to confirm
              </li>
            </ol>
            <button
              className="ios-install-modal__close"
              onClick={handleCloseModal}
              type="button"
              aria-label="Close"
            >
              Got it
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default InstallButton;
